import { render, staticRenderFns } from "./treeCate.vue?vue&type=template&id=c57259b8&scoped=true"
import script from "./treeCate.vue?vue&type=script&lang=js"
export * from "./treeCate.vue?vue&type=script&lang=js"
import style0 from "./treeCate.vue?vue&type=style&index=0&id=c57259b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57259b8",
  null
  
)

export default component.exports